import { createContext } from 'react'

type StakeListContextType = {
    /** Items matching every active filter, sorted. What the grid renders. */
    data: NFT[]
    /** Items matching category + search only — the pool the status counts describe. */
    scope: NFT[]
    filter: StakeFilter
    setCategory: (category: InventoryCategory) => void
    setStatus: (status: InventoryStatus) => void
    setSearch: (search: string) => void
    setSort: (sort: InventorySort) => void
    view: InventoryView
    setView: (view: InventoryView) => void
}

export const StakeListContext = createContext<StakeListContextType>(undefined)
